import { OrulAuthClientConfig } from '@rhaimes/react'

import { PersistentTokenStorage } from '../services/orul-token-storage'

export const orulConfig: OrulAuthClientConfig = {
  clientId: process.env.REACT_APP_ORUL_AUTH_CLIENT_ID!,
  appKey: process.env.REACT_APP_ORUL_AUTH_APP_KEY!,
  apiUrl: process.env.REACT_APP_ORUL_AUTH_API_URL ?? 'https://api.auth.orul.tech',
  baseUrl: process.env.REACT_APP_ORUL_AUTH_BASE_URL ?? 'https://auth.orul.tech',
  callbackUrl:
    process.env.REACT_APP_ORUL_CALLBACK_URL ??
    `${window.location.origin}/auth/callback`,
  origin: window.location.origin,
  storage: new PersistentTokenStorage(),
}
